var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',[_c('NavBar',{attrs:{"title":'AI MODEL DEVELOPMENT',"titleIcon":'mdi-percil-ruler',"menuItems":_vm.menuItems}}),_c('v-container',{staticClass:"pt-10 mt-10"},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }